module.exports = __webpack_public_path__ + "static/img/085.136212a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/085.png
// module id = Jv6s
// module chunks = 0